import { useNavigate } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import { Check, Sparkles } from 'lucide-react';
import CountdownTimer from '../CountdownTimer';

const planFeatures = [
  '7 dias grátis para testar',
  'Dashboard financeiro com gráficos',
  'Controle ilimitado de receitas e despesas',
  'Metas financeiras com acompanhamento visual',
  'Projeção inteligente de 12 meses',
  'Bot WhatsApp com IA (texto, áudio e foto)',
  'Quadro Kanban de tarefas financeiras',
  'Resumo diário automático por WhatsApp',
  'Relatórios por categoria e evolução mensal',
];

export default function PricingSection() {
  const [ref, isInView] = useInView({ threshold: 0.1 });
  const navigate = useNavigate();

  return (
    <section id="planos" className="relative py-32 overflow-hidden" data-testid="pricing-section">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/[0.03] to-background" />

      <div className="relative mx-auto max-w-4xl px-6" ref={ref}>
        <div className={`text-center max-w-2xl mx-auto mb-10 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/25 bg-primary/8 px-4 py-1.5 mb-5">
            <Sparkles className="w-3.5 h-3.5 text-primary" />
            <span className="text-xs font-medium text-primary">7 Dias Grátis</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-foreground mb-4">
            Comece seu teste grátis hoje
          </h2>
          <p className="text-muted-foreground text-lg mb-6">
            Teste todas as funcionalidades por 7 dias. Só paga se gostar!
          </p>
          <div className="flex justify-center">
            <CountdownTimer />
          </div>
        </div>

        <div className={`relative mx-auto max-w-md transition-all duration-1000 ${isInView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <div className="absolute -inset-4 bg-primary/15 rounded-3xl blur-2xl" />
          <div className="relative rounded-3xl border-2 border-primary bg-card p-8 pt-12 shadow-2xl overflow-hidden">
            {/* Ribbon */}
            <div className="absolute top-0 left-0 right-0 bg-primary text-primary-foreground text-center text-xs py-1.5 font-semibold tracking-widest">
              7 DIAS GRÁTIS
            </div>

            <div className="text-center">
              <h3 className="text-xl font-bold text-foreground mb-2">Plano Aretê</h3>
              <div className="inline-flex items-center gap-1.5 mb-3 px-3 py-1 rounded-full bg-rose-100 text-rose-700 text-[10px] font-bold uppercase tracking-wider">
                <span className="w-1.5 h-1.5 rounded-full bg-rose-600 animate-pulse" />
                Oferta de lançamento — 67% OFF
              </div>
              <div className="mb-1">
                <span className="text-lg text-muted-foreground line-through decoration-2 decoration-rose-500" data-testid="pricing-old-price">R$ 29,90</span>
              </div>
              <div className="flex items-baseline justify-center gap-1 mb-2">
                <span className="text-5xl font-bold text-primary" data-testid="pricing-new-price">R$ 9,90</span>
                <span className="text-muted-foreground">/mês</span>
              </div>
              <p className="text-sm text-emerald-600 font-medium mb-1">Após período de teste grátis</p>
              <p className="text-sm text-muted-foreground mb-6">Acesso completo a todas as funcionalidades com IA e WhatsApp</p>
            </div>

            <ul className="space-y-3 mb-8">
              {planFeatures.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm text-foreground/90">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => navigate('/login')}
              data-testid="pricing-cta"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl font-bold px-6 py-4 transition-all active:scale-95 shadow-[0_0_30px_-5px_hsl(var(--primary)/0.5)] hover:shadow-[0_0_40px_-5px_hsl(var(--primary)/0.7)]"
            >
              Começar Agora
            </button>
            <p className="text-center text-xs text-muted-foreground mt-4">
              Cancele quando quiser. Sem compromisso.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
